import React from 'react';
import { useTheme } from 'styled-components';

import { getColor } from '../../V2/Elements/Icons/helpers.ts';
import type { IIcon } from './types.ts';

const Icon = React.forwardRef<SVGSVGElement | null, IIcon>(function Icon({ size = 24, alt, color, className, onClick }, ref) {
  const theme = useTheme();
  const fillColor = React.useMemo(() => getColor({ color, alt, theme }), [color, alt, theme]);
  return (
    <svg ref={ref} viewBox='0 0 128 128' onClick={onClick} width={size} height={size} className={className}>
      <g>
        <rect fill='none' height='402' width='582' y='-1' x='-1' />
      </g>
      <g>
        <polygon fill='none' points='126 2 2 2 50 49.76 50 125.69 78 98.22 78 50 126 2' />
        <path
          fill={fillColor}
          d='m50,127.69a2,2 0 0 1 -2,-2l0,-75.1l-47.41,-47.17a2,2 0 0 1 1.41,-3.42l124,0a2,2 0 0 1 1.41,3.41l-47.41,47.42l0,47.39a2,2 0 0 1 -0.6,1.43l-28,27.47a2,2 0 0 1 -1.4,0.57zm-43.15,-123.69l44.56,44.35a2,2 0 0 1 0.59,1.41l0,71.16l24,-23.54l0,-47.38a2,2 0 0 1 0.59,-1.41l44.58,-44.59l-114.32,0z'
        />
      </g>
    </svg>
  );
});

export default React.memo(Icon);
